import { PopoverContent } from '../components/ui/popover';
import { usePortalDestination } from './PortalDestinationContext';
import { buildPharmacyTokens } from './lib/portalTheme';
import { usePortalTheme } from './PortalThemeContext';

/**
 * Drop-in replacement for the raw shadcn <PopoverContent> for any portal
 * popover. Radix portals popover content straight to <body>, outside the
 * `.portal-brand` DOM subtree, so without this wrapper the popover never
 * sees the pharmacy's brand tokens or the active light/dark theme.
 */
export const PortalPopoverContent = ({ className = '', children, style, ...props }) => {
  const destination = usePortalDestination();
  const { theme } = usePortalTheme();
  return (
    <PopoverContent {...props} style={{ ...buildPharmacyTokens(destination?.pharmacy, theme), ...style }}
      className={`portal-brand portal-popover ${className}`}>
      {children}
    </PopoverContent>
  );
};
